import DashNav3 from "../components/DashNav3";
import { useState } from "react";
import backarrow from '../resources/backarrow.png'
import { Link } from "react-router-dom";
import NewCreateQuoteForm from "../components/NewCreateQuoteForm";



const NewCreateQuote = () => {


 const [error,setError] = useState({message: null})
 const [success,setSuccess] = useState({message: null})

 const handleSuccess = (success) => {
     setError({message: null})
     setSuccess({message: success})
 }

 const handleError = (error) => {
     setSuccess({message: null})
     setError({message: error})
 }
    return ( 
        <div className="newcreateclientcontainer">
            <DashNav3></DashNav3>
            <div className="newcreateclientright">
            <div className="error2">
            {error.message && 
            <div className="alert alert-error" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Error! {error.message}</span>
            </div>}
            {success.message && 
            <div className="alert alert-success" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>{success.message}</span>
          </div>}
            </div> 
                <div className="newcreatetop">
                    <div className="createtopleft">
                    <Link to="/quotes" style={{textDecoration: 'none'}}>
                    <img src={backarrow} alt="" />
                    </Link>
                    <h1 className="text-3xl font-bold">Create a quote</h1>
                    </div>
                </div>
                <hr id="newline1"/>
                <NewCreateQuoteForm handleSuccess={handleSuccess} handleError={handleError}></NewCreateQuoteForm>
            </div>
        </div>
     );
}
 
export default NewCreateQuote;